<template>
        <b-btn variant="outline-secondary" size="sm"
               class="bookmarks" v-b-tooltip.hover
               :title="title" @click="addHashtag()">
            <font-awesome-icon :icon="['fas', 'bookmark']" />
        </b-btn>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex'

    export default {
        name: 'BoomarkButton',
        props: {
            hashtag: {
                default: '',
                type: String
            }
        },
        computed: {
            ...mapGetters('stats', {
                newHashtag: 'getHashtag'
            }),
            ...mapState('account', ['info']),
            title () {
                return this.info.loggedIn ? '' : 'Sign in to organize hashtags into hashtag sets.'
            }
        },
        methods: {
            ...mapActions('comparison', [
                'setBookmarkHashtag',
                'setAddToComparison',
                'setResetComparison',
                'setRemoveHashtag',
            ]),
            ...mapActions('stats', {
                getStatsInfo: 'get',
            }),
            async addHashtag () {
                if (!this.info.loggedIn) {
                    return
                }
                const tagName = this.hashtag
                if (this.newHashtag[tagName] === undefined) {
                    await this.getStatsInfo(tagName)
                }
                this.setBookmarkHashtag(this.newHashtag[tagName])

            }
        }
    }
</script>

<style scoped>

</style>
